import { z } from 'zod'
import { emailAddress } from './email-address'

export const loginSchema = z.object({
  email: emailAddress.min(5, 'Email must be at least 5 characters'),
  password: z
    .string()
    .min(8, 'Password must be at least 8 characters')
    .max(100, 'Password must not exceed 100 characters')
    .regex(/[0-9]/, 'Password must contain at least 1 number')
    .regex(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least 1 special character'),
})

export type LoginDto = z.infer<typeof loginSchema>
